import { Cmg1003Model } from './cmg-1003.model';

export interface CacheDataModel {
  snapshot?: SnapshotModel;
  cacheException?: string;
}

export interface SnapshotModel {
  Expiration?: Date;
  Fingerprint?: string;
  LastModified?: Date;

  /**
   * Our API treats `Value` as type `any`.
   * However, we use `SnapshotValueModel` to add structure to our snapshot data.
   */
  Value?: SnapshotValueModel;

  /**
   * Our API treats `Warning` as type `any`.
   * However, we use `SnapshotWarningModel` to add structure to our snapshot data.
   */
  Warning?: SnapshotWarningModel;
}

/** Custom class for the UI. */
export interface SnapshotValueModel extends Cmg1003Model {
  dirtyStores?: string[];
}

export interface SnapshotWarningModel {
  Type?: WarningType;
  Message?: string;
  UserName?: string;
  Timestamp?: Date;
}

export enum WarningType {
  ExternalUpdate = 'ExternalUpdate',
}

export interface UpsertSnapshotEntryRequest {
  fileDataId?: number;
  value?: any;
  ttl?: number;
}

export interface UpsertSnapshotEntryResponse {
  expiration?: Date;
  fingerprint?: string;
  lastModified?: Date;
  value?: any;
}
